import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DevStore {
  showOcrConfidence: boolean;
  setShowOcrConfidence: (v: boolean) => void;
}

export const useDevStore = create<DevStore>()(
  persist(
    (set) => ({
      showOcrConfidence: false,
      setShowOcrConfidence: (v) => set({ showOcrConfidence: v }),
    }),
    { name: "ophelia-dev" },
  ),
);
